// CRA 5 / webpack 5 no longer polyfill Node core globals in the browser.
// @react-pdf/renderer processes font and image binaries via Node's `Buffer`,
// so without this it throws "Buffer is not defined" whenever a PDF (or a
// registered font) is rendered. Must load before any @react-pdf code runs, so
// this module is imported first in index.js.
import { Buffer as NodeBuffer } from "buffer";

if (typeof window !== "undefined") {
    if (!window.Buffer) window.Buffer = NodeBuffer;
    if (!window.global) window.global = window;
}
